import SwitcherContainer from "../../../../../src/entities/UI/SwitcherContainer";
import { eventBus, EnumEventBus } from "../managers/EventBus";


const header = "Triangle Mode 2:";
const handleFunc = (isActive: boolean) => eventBus.emit(EnumEventBus.Triangle2Mode, isActive)
const coords = {
	vertical: { x: 180, y: 625 },
	horizontal: { x: 100, y: 480 }
}


export default class TriangleSwitcher extends SwitcherContainer {
	constructor() {
		super({ header, coords, handleFunc });

		eventBus.on(EnumEventBus.KiteMode, (v: boolean) => this.setActivation(v));
		eventBus.on(EnumEventBus.Triangle1Mode, (v: boolean) => this.setActivation(v));
	}

	setActivation(v: boolean) {
		if (v) {
			const isActive = this.Switcher.getActive();
			if (isActive) {
				this.Switcher.handleSwitcherOff();
			}
		}
	}
}